const apiUrl = process.env.REACT_APP_API_URL;
export const GetAulaIdProjecteIdTasquesId = async ( id_aula : string, id_projecte : string, id_tasca: string, id_user: string ) => {
    try {
        const response = await fetch(`${apiUrl}:8061/aules/${id_aula}/projectes/${id_projecte}/tasques/${id_tasca}/user/${id_user}`);
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
